<template>
  <v-row class="quick-actions-bar" style="height: 100%">
    <v-col class="d-flex py-0 align-center">
      <mf-icon color="branco" fill class="px-3">flash_on</mf-icon>
      <span class="align-self-center pr-3 hidden-md-and-down">Menu de ações rápidas</span>
      <span class="py-3 px-3 clients-counter">
        <mf-loading loader="evaluate-segmentation" loader-type="dynamic" :dynamic-amount="2" :dynamic-width="850">
          <span
            >{{ getSafe(() => segmentationSize.clients_qty) | localeString }} clientes selecionados de {{ getSafe(() => quickActionGroups.length) }}
            {{ getSafe(() => quickActionGroups.length) === 1 ? 'grupo' : 'grupos' }}</span
          >
        </mf-loading>
      </span>
      <mf-tooltip v-if="quickActionTooltip" max-width="300" bottom variant="secondary">
        <template #activator="{ on }">
          <mf-icon class="ml-3" dense color="branco" icon="info" />
        </template>
        {{ quickActionTooltip }}
      </mf-tooltip>
      <mf-tabs-button
        id="operator-button-groups"
        v-model="groupsOperator"
        :disabled="getSafe(() => quickActionGroups.length) < 2"
        class="ml-2"
        size="sm"
        color="marca-1-d20"
        :buttons="toggleButtons"
      />
      <v-spacer />
      <v-menu v-if="Object.values(menuVisibility.analyze).includes(true)" bottom offset-y>
        <template v-slot:activator="{ on }">
          <mf-button label="Analisar" color="branco" text :disabled="!quickActionGroups.length" v-on:click.native="on.click" />
        </template>
        <v-list class="v-list-secondary-style">
          <v-list-item v-if="menuVisibility.analyze.maria" @click="analyzeMaria">
            <v-list-item-icon class="ml-0 mx-3">
              <img :src="require('@/assets/icons/mar.ia-secondary.svg')" alt="Logo da mar.ia" />
            </v-list-item-icon>
            <v-list-item-title class="v-list-item-title-secondary-style">Previsão de vendas clube</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.analyze.revenueDecomposition" @click="revenueDecomposition">
            <v-list-item-title class="v-list-item-title-secondary-style">Decomposição de faturamento</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.analyze.rfv" @click="analyzeRFV">
            <v-list-item-title class="v-list-item-title-secondary-style">Classificação RFV</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.analyze.faturamento" @click="analyzeRevenue">
            <v-list-item-title class="v-list-item-title-secondary-style">Faturamento</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.analyze.empresaDesempenho" @click="analyzePerformanceInCompany">
            <v-list-item-title class="v-list-item-title-secondary-style">Desempenho nas lojas</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.analyze.clubeDesempenho" @click="analyzePerformanceInLoyalty">
            <v-list-item-title class="v-list-item-title-secondary-style">Desempenho no clube</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.analyze.ranking" @click="analyzeProductsRanking">
            <v-list-item-title class="v-list-item-title-secondary-style">Produtos mais vendidos</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu v-if="Object.values(menuVisibility.offers).includes(true)" bottom offset-y>
        <template v-slot:activator="{ on }">
          <mf-button label="Ofertar" color="branco" text :disabled="!quickActionGroups.length" v-on:click.native="on.click" />
        </template>
        <v-list>
          <v-list-item v-if="menuVisibility.offers.create" @click="createOfferSchedule">
            <v-list-item-title>Criar oferta</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu v-if="Object.values(menuVisibility.segmentation).includes(true)" bottom offset-y>
        <template v-slot:activator="{ on }">
          <mf-button label="Segmentar" color="branco" text :disabled="!quickActionGroups.length" v-on:click.native="on.click" />
        </template>
        <v-list>
          <v-list-item v-if="menuVisibility.segmentation.create" @click="prebuildSegment">
            <v-list-item-title>Criar segmento</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu v-if="Object.values(menuVisibility.campaigns).includes(true)" bottom offset-y>
        <template v-slot:activator="{ on }">
          <mf-button label="Comunicar" color="branco" text :disabled="!quickActionGroups.length" v-on:click.native="on.click" />
        </template>
        <v-list>
          <v-list-item v-if="menuVisibility.campaigns.sms" @click="createCampaign('sms')">
            <v-list-item-title>SMS</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.campaigns.whatsapp" @click="createCampaign('whatsapp')">
            <v-list-item-title>Whatsapp</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.campaigns.push" @click="createCampaign('aplicativo')">
            <v-list-item-title>Push</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="menuVisibility.campaigns.email" @click="createCampaign('email')">
            <v-list-item-title>E-mail</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <mf-button type="icon" color="branco" text icon="close" @click="close" />
    </v-col>
    <loading-dialog-standalone :loading="loading" />
  </v-row>
</template>

<script>
import isEqual from 'lodash/isEqual'
import truncate from 'lodash/truncate'
import { mapActions, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { quickActionFiltersCriteria, applyQuickActionsFormatters, quickActionDescriptionFormatters } from '@/helpers/quickActions.js'

export default {
  components: {
    LoadingDialogStandalone: () => import('@/components/LoadingDialogStandalone.vue'),
  },
  data: () => ({
    fab: false,
    loading: false,
    groupsOperator: 0,
  }),
  computed: {
    ...mapState({
      isSelectingQuickActionGroups: (state) => state.isSelectingQuickActionGroups,
      quickActionGroups: (state) => state.quickActionGroups,
      segmentationSize: (state) => state.segmentation.segmentationSize,
      stateFilters: (state) => state.filters,
    }),
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'OU',
          value: 0,
          active: true,
        },
        {
          id: 1,
          label: 'E',
          value: 1,
          active: true,
        },
      ]
    },
    quickActionTooltip() {
      return this.quickActionGroups.find((item) => item.tooltip)?.tooltip ?? ''
    },
    menuVisibility() {
      return {
        campaigns: {
          sms: this.$permissions.havePagePermission('campanhas/sms'),
          email: this.$permissions.havePagePermission('campanhas/email-v2') && this.$getAllowedModules()['email_v2'],
          whatsapp: this.$permissions.havePagePermission('campanhas/whatsapp') && this.$getAllowedModules()['whatsapp'] && !this.$getLoggedUser().is_franchise,
          push: this.$permissions.havePagePermission('campanhas/aplicativo') && this.$getAllowedModules()['push'],
        },
        segmentation: {
          create: this.$permissions.havePagePermission('clientes/segmentacao'),
        },
        offers: {
          create: this.$permissions.havePagePermission('campanhas/gestao_ofertas/ofertas') && this.$getAllowedModules()['offer_management'],
        },
        analyze: {
          maria: this.$permissions.havePagePermission('maria/quando-vou-vender') && this.$getAllowedModules()['forecast'],
          rfv: this.$permissions.havePagePermission('clientes/classificacao-rfv'),
          revenueDecomposition: this.$permissions.havePagePermission('empresa/decomposicao'),
          faturamento: this.$permissions.havePagePermission('empresa/faturamento'),
          empresaDesempenho: this.$permissions.havePagePermission('empresa/desempenho'),
          clubeDesempenho: this.$permissions.havePagePermission('clube/desempenho'),
          ranking: this.$permissions.havePagePermission('produtos/ranking_produtos'),
        },
      }
    },
    descriptionFormatters() {
      return quickActionDescriptionFormatters(this.stateFilters)
    },
    groupsOperatorValue() {
      if (this.groupsOperator === 0) {
        return 'OR'
      } else if (this.groupsOperator === 1) {
        return 'AND'
      }
      return ''
    },
    /*
    Quick action groups can be grouped if the 'group' property is set.
    This computed property 'groups' these different quick actions and instantiate the segmentationGroup function.
    An example of this is the case of selecting multiple neighborhoods - in which the multiple selected neighborhoods
    are grouped into a single criteria.
    */
    groupedQuickActionGroups() {
      const groups = []
      const groupedQuickActionGroups = this.quickActionGroups.reduce((acc, group) => {
        if (!group.group) {
          return [...acc, group]
        }
        const prevGroup = acc.find((accGroup) => accGroup.group === group.group)
        if (!prevGroup) {
          const newGroup = {
            values: [group.groupValue],
            group: group.group,
            segmentationGroupGenerator: group.segmentationGroup,
          }
          groups.push(newGroup)
          return [...acc, newGroup]
        }
        prevGroup.values.push(group.groupValue)
        return acc
      }, [])
      groups.forEach((group) => {
        group.segmentationGroup = group.segmentationGroupGenerator(group.values, this.groupsOperatorValue)
      })
      return groupedQuickActionGroups
    },
    segmentData() {
      const filtersCriteria = quickActionFiltersCriteria(this.stateFilters)
      return {
        groups: this.groupedQuickActionGroups.map((group) => {
          if (group.segmentationGroup instanceof Function) {
            return group.segmentationGroup(filtersCriteria)
          } else {
            return group.segmentationGroup
          }
        }),
        operator: this.groupsOperatorValue,
      }
    },
    disabled() {
      return !this.quickActionGroups?.length
    },
    shortDescription() {
      if (!this.groupedQuickActionGroups?.length) {
        return ''
      } else if (this.groupedQuickActionGroups?.length === 1) {
        return applyQuickActionsFormatters(this.quickActionGroups[0].shortDescription, this.descriptionFormatters, this.groupedQuickActionGroups[0].values)
      } else {
        // Multiple groups have empty short descriptions
        return `${document.title} - Vários grupos`
      }
    },
    longDescription() {
      if (!this.groupedQuickActionGroups?.length) {
        return ''
      } else if (this.groupedQuickActionGroups?.length === 1) {
        return applyQuickActionsFormatters(this.quickActionGroups[0].longDescription, this.descriptionFormatters, this.groupedQuickActionGroups[0].values)
      } else {
        // Return a concatenation of the short descriptions as a long descriptions
        const operator = this.groupsOperator === 0 ? 'OU' : 'E'
        return truncate(
          this.quickActionGroups.map((group) => applyQuickActionsFormatters(group.shortDescription, this.descriptionFormatters)).join(` ${operator} `),
          {
            length: 150,
            separator: ' ',
          }
        )
      }
    },
  },
  watch: {
    fab(value) {
      if (value !== this.isSelectingQuickActionGroups) {
        this.setIsIncludingSegments(value)
      }
    },
    isSelectingQuickActionGroups(value) {
      this.fab = value
    },

    segmentData: {
      handler(newData, oldData) {
        if (!isEqual(newData, oldData)) {
          this.localEvaluateSegmentation()
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.fab = true
    this.localEvaluateSegmentation()
  },
  destroyed() {
    this.setIsIncludingSegments(false)
  },
  methods: {
    ...mapActions(['setIsIncludingSegments', 'setQuickAction', 'saveSegment']),
    ...mapWaitingActions({
      evaluateSegmentation: 'evaluate-segmentation',
    }),
    async localEvaluateSegmentation() {
      try {
        await this.evaluateSegmentation({ segment: this.segmentData, forceUpdate: true, skipRFVClusters: true })
      } catch (e) {
        this.$snackbar({ message: 'Falha ao calcular o tamanho do segmento.', snackbarColor: 'error' })
      }
    },
    async createHiddenAutoSegment() {
      const segment = {
        name: this.shortDescription,
        description: this.longDescription,
        hidden: true,
        auto: true,
        fixed: true,
        data: this.segmentData,
      }

      const response = await this.saveSegment(segment)

      // Drop criteria - as they are not needed by campaigns and can be potentially big
      // If data is deleted, it breaks quick actions in pages that were loaded from quick actions
      // delete response.data

      return response
    },

    async createSegmentAndReroute(path) {
      try {
        this.loading = true
        const segment = await this.createHiddenAutoSegment()
        this.loading = false
        this.setQuickAction({ segmentation: { segment, title: this.shortDescription, description: this.longDescription } })
        const newTab = this.$router.resolve({ path, query: { quick_action: true } })
        window.open(newTab.href, '_blank')
      } catch (e) {
        console.error(e)
        this.$snackbar({ message: 'Falha ao criar o segmento automatico.', snackbarColor: 'error' })
        this.loading = false
      }
    },

    async prebuildSegment() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de segmentação.',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      this.setQuickAction({ segmentation: { segment: this.segmentData, title: this.shortDescription, description: this.longDescription } })
      const newTab = this.$router.resolve({ path: '/clientes/segmentacao/nova', query: { quick_action: true } })
      window.open(newTab.href, '_blank')
    },

    async createCampaign(mode) {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de criação de campanha.',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }

      await this.createSegmentAndReroute(`/campanhas/${mode}/nova`)
    },

    async createOfferSchedule() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de criação de ofertas.',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }

      await this.createSegmentAndReroute('/campanhas/gestao-ofertas/nova')
    },

    async analyzeProductsRanking() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de ranking de produtos',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      await this.createSegmentAndReroute('/produtos/ranking-produtos')
    },
    async analyzeRevenue() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de faturamento',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      await this.createSegmentAndReroute('/empresa/faturamento')
    },

    async analyzeRFV() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de RFV',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      await this.createSegmentAndReroute('/clientes/classificacao-rfv')
    },
    async revenueDecomposition() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de decomposição de faturamento',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      await this.createSegmentAndReroute('/empresa/decomposicao')
    },
    async analyzePerformanceInCompany() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de desempenho das lojas',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      await this.createSegmentAndReroute('/empresa/desempenho')
    },
    async analyzePerformanceInLoyalty() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de desempenho do clube',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      await this.createSegmentAndReroute('/clube/desempenho')
    },
    async analyzeMaria() {
      const confirmed = await this.$confirm({
        message: 'Você será redirecionado para a tela de análises com a mar.ia',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      await this.createSegmentAndReroute('/maria/quando-vou-vender')
    },
    close() {
      this.fab = false
    },
  },
}
</script>

<style lang="scss">
.quick-actions-bar {
  background: $marca-1;
  .clients-counter {
    background: $marca-1-d20;
    height: 100%;
    text-align: center;
    min-width: 300px;
  }
  #operator-button-groups {
    .v-btn.v-btn--active.operator-button {
      background-color: $branco;
      color: $marca-1;
    }
    .operator-button {
      background-color: $marca-1-d20;
    }
  }
}
.v-list-secondary-style {
  background-color: $marca-1-d20 !important;
  .v-list-item-title-secondary-style {
    color: $branco !important;
  }
}
</style>
